// Catálogo das partes de personagem, por id.

import type { BodyDef, OverlayDef } from '../types.js';
import { ACCESSORIES } from './accessories.js';
import { BODIES } from './bodies.js';
import { HAIRS } from './hair.js';
import { OUTFITS } from './outfits.js';

export { ACCESSORIES, BODIES, HAIRS, OUTFITS };

const byId = <T extends { id: string }>(list: readonly T[]) => new Map(list.map((x) => [x.id, x]));

export const BODY_BY_ID: ReadonlyMap<string, BodyDef> = byId(BODIES);
export const HAIR_BY_ID: ReadonlyMap<string, OverlayDef> = byId(HAIRS);
export const OUTFIT_BY_ID: ReadonlyMap<string, OverlayDef> = byId(OUTFITS);
export const ACCESSORY_BY_ID: ReadonlyMap<string, OverlayDef> = byId(ACCESSORIES);
